import { format } from "date-fns";
export const timeFromSecondsSinceEpoch = (seconds) => {
  return new Date(seconds * 1000);
}

export const dateString = (time) => {
  return format(time, 'yyyy-MM-dd')
}

export const datetimeString = (time) => {
  return format(time, 'yyyy-MM-dd @ hh:mm')
}

export const datetimeStringFromSecondsSinceEpoch = (seconds) => {
  const time = timeFromSecondsSinceEpoch(seconds)
  return datetimeString(time)
}

export const timeString = (time) => {
  return format(time, 'hh:mmaaa')
}

export const timeStringFromSecondsSinceEpoch = (seconds) => {
  const time = timeFromSecondsSinceEpoch(seconds)
  return timeString(time)
}

export const dateStringFromSecondsSinceEpoch = (seconds) => {
  const time = timeFromSecondsSinceEpoch(seconds)
  return dateString(time)
}

export const currentSecondsSinceEpoch = () => {
  return Math.floor(Date.now() / 1000)
}
